<template>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="500"
    >
      <v-card class="upgrade-card" style="background: #f5f5f5;">
        <v-btn
          icon
          absolute
          top
          right
          @click="dialog = false"
          style="background: transparent;"
        >
          <v-icon color="#333">mdi-close</v-icon>
        </v-btn>
        <v-card-text class="text-center pt-8 pb-6">
          <div class="upgrade-icon mb-6">
            <v-icon size="60" color="#00d084">mdi-rocket</v-icon>
          </div>
          
          <h2 class="text-h5 font-weight-bold mb-4" style="color: #000;">Our system has been upgraded</h2>
          
          <p class="text-body2 mb-8" style="color: #333; line-height: 1.6;">
            We are pleased to announce that Cloudeka AI is now available on a new, faster, and more reliable platform. Your account is ready to use — no re-registration required.
          </p>
          
          <v-btn
            href="https://ai.cloudeka.id"
            target="_blank"
            large
            color="primary"
            class="mb-4 px-6"
            style="text-transform: none; font-size: 16px;"
          >
            <v-icon left size="20">mdi-web</v-icon>
            ai.cloudeka.id
          </v-btn>
          
          <div class="info-box mb-4 pa-4" style="background: #e8e8e8; border-radius: 8px; text-align: left;">
            <v-icon size="24" color="#333" class="mr-3">mdi-shield-check</v-icon>
            <span style="color: #000; font-size: 14px;">
              You can sign in using your <strong style="color: #000;">existing username and password</strong> — your credentials work on the new platform without any changes.
            </span>
          </div>
          
          <div class="info-box mb-6 pa-4" style="background: #e8e8e8; border-radius: 8px; text-align: left;">
            <v-icon size="24" color="#333" class="mr-3">mdi-email</v-icon>
            <span style="color: #000; font-size: 14px;">
              If you have trouble logging in, you can contact our service department at 
              <a href="mailto:info@cloudeka.id" style="color: #1976d2; text-decoration: none;">info@cloudeka.id</a>
            </span>
          </div>
          
          <v-btn
            @click="goToNewSystem"
            large
            color="primary"
            class="px-8"
            style="text-transform: none; font-size: 16px;"
          >
            Go to new system
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
          
          <p class="text-caption mt-6 mb-0" style="color: #666;">
            <v-icon x-small>mdi-information-outline</v-icon>
            The old system will be retired soon
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
import { useDialog } from '@/composable/usedialog'
import { ref } from '@vue/composition-api'

export default {
    props: ['value'],
    setup(props, context) {
      const { dialog } = useDialog(props, context)
      
      const goToNewSystem = () => {
        window.location.href = 'https://ai.cloudeka.id'
      }

      return {
        dialog,
        goToNewSystem
      }
    },
}
</script>
